import React from "react";
import { connect } from "react-redux";
import Redirect from "utils/Redirect";
import appConfig from "utils/appConfig";
import { SCREENS } from "../../../../common/constants/Constants";

export function mapStateToProps(state) {
    const {
        studentForm: {
            isDocUpload,
            studentId,
            redirectTo
        } = {}
    } = state;

    return {
        isDocUpload,
        studentId,
        redirectTo
    };
}

const mapDispatchToProps = () => ({
    redirectToOffers() {
        Redirect.redirectTo(`${ appConfig().bloombergSiteUrl }${ SCREENS.SUBSCRIPTIONS }`);
    }
});

const StudentDocumentUploadContainer = ({
    isDocUpload,
    studentId,
    redirectTo,
    redirectToOffers
}) => {
    if (!isDocUpload || !studentId || !redirectTo) {
        redirectToOffers();
    }

    return (
        <div style={ { maxWidth: "480px", margin: "50px auto 0", height: "650px" } }>
            <iframe
                title="Document Upload"
                src={ `${ appConfig().sheerIdDocUploadUrl }?verificationId=${ studentId }&redirectUrl=${ encodeURIComponent(redirectTo) }` }
                frameBorder="0"
                width="100%"
                height="100%"
            />
        </div>
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentDocumentUploadContainer);
